module.exports = __webpack_public_path__ + "img/Support-skill-125.990db852.png";